/*
 * @Description: 
 * @Author: 唐胜建
 * @Date: 2021-11-19 18:24:43
 * @LastEditTime: 2021-11-21 18:12:06
 */
import { VueExtension } from '../../utils/extensions/vue';
import CollapseItem from './collapseitem.jsx';
import './collapseitem.scss';

VueExtension.WithInstall(CollapseItem);

export default CollapseItem;
